import { registerPlugin } from '@capacitor/core';
const AudioPermissions = registerPlugin('AudioPermissions', {
    web: () => import('./web').then(m => new m.AudioPermissionsWeb()),
});
export * from './definitions';
export { AudioPermissions };
//# sourceMappingURL=index.js.map